"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRegistrationsMetadata = void 0;
var _environment = require("@ori/environment");
var _staticApiClientReact = require("@ori/static-api-client-react");
var _swr = _interopRequireDefault(require("swr"));
var _contexts = require("../../../contexts");
var _useTranslations_simplifiedRegistrationBrandPartner = require("../../../hooks/useTranslations_simplified-registration-BrandPartner");
var _interfaces = require("../../../interfaces");
var _FetchResult = require("../../FetchResult");
var _TranslationKey_simplifiedRegistrationBrandPartner = require("../../TranslationKey_simplified-registration-BrandPartner");
async function fetchRegistrationsMetadata(api, tenant, registrationType) {
  const emptyRegistrationsMetadata = {
    isEnabled: false,
    isRedirectToBasketEnabled: false
  };
  try {
    const response = await (0, _staticApiClientReact.getTenantCustomerRegistrationsMetadatumRegistrationsMetadata)(api, tenant, registrationType);
    return new _FetchResult.FetchResult(response.status, response.data);
  } catch (error) {
    return _FetchResult.FetchResult.errorFor(emptyRegistrationsMetadata);
  }
}
const useRegistrationsMetadata = () => {
  const {
    registrationType
  } = (0, _contexts.useConfiguration)();
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    formatMessage
  } = (0, _useTranslations_simplifiedRegistrationBrandPartner.useTranslations)();
  const staticApi = (0, _staticApiClientReact.useApiClient)();
  const {
    notificationData
  } = (0, _contexts.useNotificationData)();
  const {
    setNotificationData
  } = notificationData;
  const errorMeesage = formatMessage(_TranslationKey_simplifiedRegistrationBrandPartner.TranslationKey.cannotGetData);
  return (0, _swr.default)([tenant, registrationType, 'registrationsMetadata'], async () => {
    const result = await fetchRegistrationsMetadata(staticApi, tenant, registrationType);
    if (result.isSuccess() && result.response) {
      return result.response;
    }
    throw new Error('request failed fetch registartion metadata');
  }, {
    revalidateOnFocus: false,
    onError(err) {
      if (err) {
        setNotificationData({
          isOpen: true,
          message: errorMeesage,
          type: _interfaces.MessageType.error,
          messageId: 'cannotGetData'
        });
      }
    }
  });
};
exports.useRegistrationsMetadata = useRegistrationsMetadata;